import { render, staticRenderFns } from "./mainModal.vue?vue&type=template&id=485f6a25&"
import script from "./mainModal.vue?vue&type=script&lang=js&"
export * from "./mainModal.vue?vue&type=script&lang=js&"
import style0 from "./mainModal.vue?vue&type=style&index=0&id=485f6a25&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports